import CitizenshipWrapper from 'features/signup/Citizenship/CitizenshipWrapper';
import React from 'react';

export default function Page() {
  return <CitizenshipWrapper />;
}
